import { Button } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";

import Axios from "screens/EnghelabSchoolForm/axios";
import DeleteActivityDialog from "screens/Activity/components/DesktopPage/components/ActivityActions/DeleteActivityDialog";
import { toast } from "react-toastify";

export default function ActivitesList(props) {
  const [activities, setActivities] = React.useState([]);
  const [stepActs, setStepActs] = React.useState([]);
  const [tRef, setTRef] = useState(0);
  useEffect(() => {
    const getActs = async () => {
      try {
        const { data } = await Axios.post(
          "/a/enghelab-school/group/activity-history/" +
            localStorage.getItem("enghelabSchoolId") +
            "/",
          {
            step: props.step,
          }
        );
        setStepActs(data);
        // if (data.length > 0) {
        //   setStepActs(data);
        //   let reqs = data.map((item) => {
        //     return Axios.get("/a/act/activity-detail/" + item.activity_slug);
        //   });
        //   Promise.all(reqs)
        //     .then((res) => {
        //       //   console.log(res);
        //       setActivities(res.map((item) => item.data));
        //     })
        //     .catch((e) => {
        //       console.log(e);
        //     });
        // }
      } catch (error) {
        console.log(error);
      }
    };
    getActs();
  }, [props?.refresh, tRef]);
  const getActSubmit = (act) => {
    let d = new Date(act);
    return `${d.getFullYear()}/${d.getMonth() + 1}/${d.getDate()}`;
  };

  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteSlug, setDeleteSlug] = useState(null);
  const [AcceptAccept, setAcceptAccept] = useState(false);
  const [ActId, setActId] = useState(null);

  const deleteHandler = (s) => {
    // console.log(s);
    setShowDeleteModal(true);
    setDeleteSlug(s.activity_slug);
    setActId(s._id);
  };

  const deleteActivity = async () => {
    var myHeaders = new Headers();
    myHeaders.append(
      "Authorization",
      `token ${localStorage.getItem("aghighToken")}`
    );

    var formData = new FormData();

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: formData,
      redirect: "follow",
    };
    try {
      await Axios.post("/a/act/activity-remove/" + deleteSlug + "/");
      setShowDeleteModal(false);
      setDeleteSlug(null);
      toast.success("فعالیت با موفقیت حذف شد");

      await Axios.delete(`a/enghelab-school/act/report/${deleteSlug}`);
      setTRef(!tRef);
      setActId(null);
      setActivities([]);
      setStepActs([]);
    } catch (error) {
      setShowDeleteModal(false);

      toast.error("حذف فعالیت موفق نبود");
      console.error(error);
    }

    // fetch(Apis.baseUrl + `a/act/activity-remove/${slug}/`, requestOptions)
    //   .then((response) => {
    //     if (response.status === 200 || response.status === 204) {
    //       setDeleteDialog(false);
    //       dispatch(showSuccess({ message: "فعالیت با موفقیت حذف شد" }));
    //       setAcceptAccept(true);
    //       dispatch(removeMyActivity(slug));

    //       history.push("/activities/myactivity");
    //     } else {
    //       setDeleteDialog(false);
    //       dispatch(showError({ message: "خطایی رخ داده است" }));
    //     }
    //   })
    //   .catch((error) => {
    //     dispatch(showError({ message: "خطایی رخ داده است" }));
    //   });
  };

  return (
    <div className="ActivitesListSection">
      <div className="ActivitesListSection__Table">
        <table>
          <thead>
            {!!stepActs.length && (
              <tr>
                <th>ردیف</th>
                <th>نام فعالیت</th>
                <th>ایجاد کننده</th>
                <th>تاریخ ثبت</th>
                <th></th>
              </tr>
            )}
          </thead>
          <tbody>
            {stepActs?.map((item, index) => {
              return (
                <tr key={index}>
                  <td>{index + 1}</td>
                  <td>{item?.actName || "[بزودی نمایش داده میشود...]"}</td>
                  <td>{item?.creator?.name}</td>
                  <td
                    style={{
                      direction: "ltr",
                    }}
                  >
                    {getActSubmit(item.submit_at)}
                  </td>
                  <td>
                    <a
                      className="actShowLink"
                      target="_blank"
                      href={`/activity/detail/${item.activity_slug}`}
                    >
                      مشاهده
                    </a>

                    <Button onClick={() => deleteHandler(item)}>
                      <DeleteForeverIcon style={{ color: "#f26868" }} />
                    </Button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      <DeleteActivityDialog
        slug={deleteSlug}
        deleteDialog={showDeleteModal}
        setDeleteDialog={setShowDeleteModal}
        setAcceptAccept={setAcceptAccept}
        enghlabSchool={deleteActivity}
      />
    </div>
  );
}
